import { Routes } from "@angular/router";
import { ProfileComponent } from "./profile/profile.component";
import { AddressComponent } from "./address/address.component";
import { AuthGuard } from "../../Services/authentification/guards/auth.guard";
import { OrdersComponent } from "./orders/orders.component";
import { OrderDetailsComponent } from "./orders/order-details/order-details.component";
import { KEEP_ON_LANGUAGE_CHANGE } from "../../Services/language.service";

export const UserAccountRoutes: Routes = [
  {
    path: "profile",
    component: ProfileComponent,
    canActivate: [AuthGuard],
    data: KEEP_ON_LANGUAGE_CHANGE,
  },
  {
    path: "address",
    component: AddressComponent,
    canActivate: [AuthGuard],
    data: KEEP_ON_LANGUAGE_CHANGE,
  },
  {
    path: "orders",
    component: OrdersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "orders/:id",
    component: OrderDetailsComponent,
    // the header sends the client back home on logout from a page guarded by AuthGuard
    canActivate: [AuthGuard],
  },
];
